import React from 'react';

import { RichTextBlockData } from 'api/cms';
import { RichText } from 'components/Text';

type Props = {
  data: RichTextBlockData;
  fullWidthLayout?: boolean;
  isSidebar?: boolean;
};

export function AmpRichTextBlock({
  data: { html },
  fullWidthLayout,
  isSidebar,
}: Props) {
  return (
    <RichText
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      textAlign={fullWidthLayout && 'center'}
      small={isSidebar}
      requestIsAmp
    />
  );
}
